export default __webpack_public_path__ + "static/char-46-3427115e289dca2ad3d4552454dd3702.webp";